import { defineStore } from "pinia";
import type { Router } from "vue-router";
import { ERROR_CODE, ERROR_PAGE_URI } from "@/constants";
import type { IError } from "@/view-models/Common/IError";

export const useGlobalErrorStore = defineStore("globalError", {
  state: (): {
    error: Partial<IError>;
  } => {
    return {
      error: {},
    };
  },
  actions: {
    setError(error: IError): void {
      this.error = error;
    },
    getError(errorCode: number): IError {
      switch (errorCode) {
        case ERROR_CODE.AUTHENTICATION_SERVER:
          return {
            title: "Fejl",
            message:
              "Desværre er der opstået et uventet problem på brugergodkendelsesserveren. Prøv venligst igen eller kontakt support.",
            links: [
              {
                label: "Genindlæs side",
                url: "index",
              },
              {
                label: "Driftsstatus",
                url: "https://oes.dk/digitale-loesninger/driftsstatus/",
              },
              {
                label: "SBRL Portal",
                url: "https://sbrl.oes.dk",
              },
            ],
          };
        case ERROR_CODE.DEFAULT:
        default:
          return {
            title: "Fejl",
            message:
              "Der er desværre opstået et uventet problem. Prøv igen eller kontakt supporten.",
            links: [
              {
                label: "Genindlæs side",
                url: "index",
              },
              {
                label: "Driftsstatus",
                url: "https://oes.dk/digitale-loesninger/driftsstatus/",
              },
              {
                label: "SBRL Portal",
                url: "https://sbrl.oes.dk",
              },
            ],
          };
      }
    },
    redirect(errorCode: number, router: Router): void {
      const error = this.getError(errorCode);
      this.setError(error);
      router.push(ERROR_PAGE_URI);
    },
  },
});
